define('frontend-common-components/objectStorageConfig/js/helpers/bucketSpecifyTemplateHelper',[
], function () {
    'use strict';
    return function (properties) {
        return {
            bucketConfigurationLabel: function () {
                return properties.bucketConfigurationLabel;
            },

            bucketSpecifiedInConfiguration: function () {
                return properties.bucketSpecifiedInConfiguration;
            }
        };
    };
});

